import { Routes } from '@angular/router';
import { authGuard } from './gaurd/auth.guard';
import { permissionGuard } from './gaurd/permission.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./module/userLogin/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'property-select',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./module/Panel/property-select/property-select.page').then(m => m.PropertySelectPage),
  },
  {
    path: 'folder',
    canActivate: [authGuard],
    loadComponent: () => import('./folder/folder.page').then(m => m.FolderPage),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./module/Panel/dashboard/dashboard.page').then(m => m.DashboardPage),
    children: [
      { path: '', redirectTo: 'task-category', pathMatch: 'full' },

      // ── Task Management ───────────────────────────────────────
      {
        path: 'task-category',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/task-category/task-category.page').then(m => m.TaskCategoryPage),
      },
      {
        path: 'task',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/task/task.page').then(m => m.TaskPage),
      },
      {
        path: 'create-check-list/:id',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/create-check-list/create-check-list.page').then(m => m.CreateCheckListPage),
      },
      {
        path: 'checklist-listing',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/checklist-listing/checklist-listing.page').then(m => m.ChecklistListingPage),
      },

      // ── User Management ───────────────────────────────────────
      {
        path: 'user-list',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/user-list/user-list.page').then(m => m.UserListPage),
      },
      {
        path: 'create-user',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/create-user/create-user.page').then(m => m.CreateUserPage),
      },
      {
        path: 'create-user/:id',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/create-user/create-user.page').then(m => m.CreateUserPage),
      },
      {
        path: 'pending-approvals',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/pending-approvals/pending-approvals.page').then(m => m.PendingApprovalsPage),
      },

      // ── Role Management (RBAC) ────────────────────────────────
      {
        path: 'roles',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/roles/roles.page').then(m => m.RolesPage),
      },
      {
        path: 'role-form/:id',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/role-form/role-form.page').then(m => m.RoleFormPage),
      },

      // ── Legacy user-role page (kept for backward compat) ──────
      {
        path: 'user-role',
        loadComponent: () =>
          import('./module/Panel/user-role/user-role.page').then(m => m.UserRolePage),
      },

      // ── Reports ───────────────────────────────────────────────
      {
        path: 'report',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/report/report.page').then(m => m.ReportPage),
      },

      // ── Complaints ────────────────────────────────────────────
      {
        path: 'complaint-list',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/complaint-register/complaint-list/complaint-list.page').then(m => m.ComplaintListPage),
      },
      {
        path: 'ticket-list',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/complaint-register/tickets-list/tickets-list.page').then(m => m.TicketsListPage),
      },
      {
        path: 'complaint-detail/:id',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/complaint-register/complaint-detail/complaint-detail.page').then(m => m.ComplaintDetailPage),
      },
      {
        path: 'raise-complaint',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/complaint-register/raise-complaint/raise-complaint.page').then(m => m.RaiseComplaintPage),
      },
      {
        path: 'complaint-report',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/complaint-register/complaint-report/complaint-report').then(m => m.ComplaintReport),
      },

      // ── Announcements ─────────────────────────────────────────
      {
        path: 'announcement-list',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/announcement-list/announcement-list.page').then(m => m.AnnouncementListPage),
      },
      {
        path: 'announcement-create',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./module/Panel/announcement-create/announcement-create.page').then(m => m.AnnouncementCreatePage),
      },

      // ── Properties (admin-only, not permission-guarded) ───────
      {
        path: 'property-listing',
        loadComponent: () =>
          import('./module/Panel/property-listing/property-listing.page').then(m => m.PropertyListingPage),
      },
      {
        path: 'add-property',
        loadComponent: () =>
          import('./module/Panel/add-property/add-property.page').then(m => m.AddPropertyPage),
      },
      {
        path: 'add-property/:id',
        loadComponent: () =>
          import('./module/Panel/add-property/add-property.page').then(m => m.AddPropertyPage),
      },

      {
        path: 'organization',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./module/Panel/organization/list-organization/listing.page').then(m => m.OrganizationPage),
      },

      {
        path: 'add-organization',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./module/Panel/organization/add-organization/add-organization').then(m => m.AddEditOrganization),
      },

      {
        path: 'add-organization/:id',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./module/Panel/organization/add-organization/add-organization').then(m => m.AddEditOrganization),
      },
    ],
  },
  {
    path: 'add-task',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./module/Panel/add-task/add-task.page').then(m => m.AddTaskPage),
  },
  {
    path: 'user-rights',
    loadComponent: () =>
      import('./module/Panel/user-rights/user-rights.page').then(m => m.UserRightsPage),
  },
];
